export class Address {
    StreetAddress : string;
    City : string;
    State : string;
    Zip : string;
    Unit : number;
    County : string;
}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/Address.ts